<template>
  <div class="container-fluid">
    <div slot="header" class="form-header">
      <h3>{{ $t("PROPERTIES.EDIT_PROPERTY") }}</h3>
    </div>
    <property-form
      :loading="loading"
      :propertyData="property"
      :formErrors="formErrors"
      @propertySubmitted="handleSubmit"
      @formChanged="() => (alertLeave = true)"
    />
  </div>
</template>

<script>
import PropertyForm from "../partials/PropertyForm.vue";
import { cloneDeep } from "lodash";
import alertLeave from "@/mixins/alert-leave-mixin";
import requestErrorMixin from "@/mixins/request-error-mixin";
import defaultProperty from "../defaultProperty";

export default {
  layout: "DashboardLayout",

  components: { PropertyForm },

  mixins: [alertLeave, requestErrorMixin],

  props: {
    propertyId: {
      type: [String, Number],
      required: true,
    },
  },

  data() {
    return {
      property: cloneDeep(defaultProperty),
      formErrors: null,
      loading: false,
    };
  },

  created() {
    this.get();
  },

  methods: {
    formatDateToYYYYMMDD(isoDate) {
      const dateObj = new Date(isoDate);
      const [yearItem, monthItem, dayItem] = isoDate.split('T')[0].split('-');
      const date = new Date(yearItem, monthItem - 1, dayItem);
      const year = yearItem;
      const month = monthItem; // Les mois commencent à 0
      const day = dayItem;

      return `${year}-${month}-${day}`;
    },
    async get() {
      this.loading = true;
      try {
        await this.$store.dispatch("propertiesCollections/get", this.propertyId);
        this.property = this.$store.getters["propertiesCollections/propertiesCollection"];
        if (this.property.registrationDivision === null) {
          this.property.registrationDivision = { id: null, type: "registration-divisions", };
        }
        /*if(this.property.sold_at){
          this.property.sold_at = this.formatDateToYYYYMMDD(this.property.sold_at);
        }
        if(this.property.end_at){
          this.property.end_at = this.formatDateToYYYYMMDD(this.property.end_at);
        }*/
        this.loading = false;
      } catch (error) {
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
        this.loading = false;
      }
    },

    async handleSubmit(property) {
      this.loading = true;
      const propertyData = cloneDeep(property);

      try {
        if (propertyData.id === null) propertyData.registrationDivision = null
        await this.$store.dispatch("propertiesCollections/update", propertyData);
        this.$notify({
          type: "success",
          message: this.$t("PROPERTIES.PROPERTY_UPDATED"),
        });
        const property = await this.$store.getters["propertiesCollections/propertiesCollection"];
        this.$emit("onViewProperty", property, true);
        this.loading = false;
      } catch (error) {
        console.log(error);
        if (error?.response?.status === 403) {
          await this.showRequestError(error);
        } else if (error.response.status === 400) {
          await this.showRequestError(error);
        } else {
          this.$notify({
            type: "danger",
            message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
          });
          this.formErrors = error.response.data.errors;
        }
        this.loading = false;
      }
    },
  },
};
</script>
